// extracted by mini-css-extract-plugin
export default {"imageWrapper":"pG-z","twoColumnImage":"qG-z"};